<!-- Zweck: Stellt die HTML-Struktur für shop artikel verfuegbarkeit inline info component im Frontend bereit. -->
@if (data && data.Verfuegbarkeitsinformation) {
  <div class="infoboxinline">
    @if (data.Nachfolgeartikel) {
      <h1>Nachfolge Artikel vorhanden!</h1>
      <hr>
        <h3>
          {{data.Nachfolgeartikel.ArtikelName}} <article-dtp-icon [isDtp]="data.Nachfolgeartikel.IstDtpArtikel"></article-dtp-icon>
        </h3>
        <div style="text-align: center">
          <table style="margin: auto">
            <tr>
              <th>EP:</th>
              <td>{{data.Nachfolgeartikel.Kundeneinkaufspreis}} &euro;</td>
              <td></td>
              <th>VP:</th>
              <td>{{data.Nachfolgeartikel.Kundenverkaufspreis}} &euro;</td>
            </tr>
          </table>
        </div>
      }
      @for (i of data.Verfuegbarkeitsinformation; track i) {
        <div>
          @if (i.color=='green') {
            <svg-icon [size]="30" class="infoicon infoicon-green">success-bk</svg-icon>
          }
          @if (i.color=='orange') {
            <svg-icon [size]="30" class="infoicon infoicon-orange">rueckstaende</svg-icon>
          }
          @if (i.color=='orange2') {
            <svg-icon [size]="30" class="infoicon infoicon-orange2">success-bk</svg-icon>
          }
          @if (i.color=='red') {
            <svg-icon [size]="30" class="infoicon infoicon-red">abbrechen</svg-icon>
          }
          {{i.Menge}} ST - {{i.InfoText}}
          @if (i.Zusatzinformation && i.Zusatzinformation.length > 0 && false) {
            <div>
              <table>
                <tr>
                  <td class="label label2">Details:</td>
                  <td class="info info2" colspan="2">
                    @for (txt of i.Zusatzinformation; track txt) {
                      <div>
                        {{txt.text}}
                      </div>
                    }
                  </td>
                </tr>
              </table>
            </div>
          }
        </div>
      }
    </div>
  }
